module.exports = __webpack_public_path__ + "static/img/bolhas.95abc83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/bolhas.jpg
// module id = mQo6
// module chunks = 0